import { Button, InputField } from '@fairygodboss/ui';
import React from 'react';

import { buildImagePath } from '../../utils/images';

import ErrorLabel from './ErrorLabel';
import Overlay from './Overlay';

export default class ConfirmationPopup extends React.PureComponent {
    handleButtonClick = (onClickHandler, redirectUrl) => (event) => {
        if (!redirectUrl) {
            event.preventDefault();
        }

        if (onClickHandler) {
            onClickHandler();
            return;
        }

        this.props.onClose();
    };

    renderButton = ({
        onClickHandler,
        buttonText,
        redirectUrl,
        buttonType,
        cssClass = '',
    }) => (
        <a key={buttonText} href={redirectUrl}>
            <Button
                onPress={this.handleButtonClick(onClickHandler, redirectUrl)}
                variant={buttonType}
                className={`popup-button ${cssClass} ${buttonType}`}
            >
                {buttonText}
            </Button>
        </a>
    );

    render() {
        const {
            buttonMetas,
            cssClass,
            heading,
            imageSrc,
            inputOnChange,
            onClose,
            subheading,
        } = this.props;

        return (
            <div className={`component-ConfirmationPopup ${cssClass}`}>
                <style global jsx>
                    {`
                        .popup-button {
                            width: 129px;
                            border-radius: 0px;
                            height: 40px;
                        }
                        .popup-button.secondary {
                            background-color: #8e9db9;
                            color: #fff;
                            border: none;
                        }
                        .component-ConfirmationPopup {
                            position: fixed;
                            top: 0;
                            bottom: 0;
                            left: 0;
                            right: 0;
                            z-index: 300;
                        }
                        .component-ConfirmationPopup
                            .flex-align-justify-center {
                            display: flex;
                            justify-content: center;
                            align-items: center;
                        }
                        .component-ConfirmationPopup .modal-scroll {
                            height: 100%;
                            width: 100%;
                            padding: 5vh 0;
                            overflow-y: auto;
                            display: flex;
                            align-items: center;
                        }
                        .component-ConfirmationPopup .popup-container {
                            margin: auto;
                            z-index: 100;
                            width: 95vw;
                        }
                        .component-ConfirmationPopup .popup-content {
                            background-color: #fff;
                            flex-direction: column;
                            text-align: center;
                            height: 560px;
                        }
                        .component-ConfirmationPopup .popup-content img {
                            height: 100px;
                            width: 60px;
                        }
                        .component-ConfirmationPopup .popup-content > span {
                            width: 240px;
                            text-align: center;
                            word-break: break-word;
                        }
                        .component-ConfirmationPopup
                            .popup-content
                            > span.heading {
                            font-family: "Open Sans", sans-serif;
                            font-size: 22px;
                            font-weight: 200;
                            min-height: 70px;
                            line-height: 1.21;
                            letter-spacing: -0.4px;
                        }
                        .component-ConfirmationPopup
                            .popup-content
                            > span.subheading {
                            font-size: 14px;
                            font-style: italic;
                            min-height: 65px;
                            line-height: 1.43;
                        }
                        .component-ConfirmationPopup .popup-button {
                            display: flex;
                            justify-content: center;
                            width: 120px;
                            margin-top: 20px;
                        }
                        .component-ConfirmationPopup .popup-button input {
                            width: 100%;
                            height: auto;
                            padding: 10px 0;
                        }
                        .component-ConfirmationPopup .popup-input {
                            background-color: #f3f5f8;
                            padding: 16px;
                            width: 240px;
                            margin-top: 10px;
                        }
                        .component-ConfirmationPopup
                            .button-row
                            a:nth-child(odd)
                            .popup-button {
                            margin-right: 10px;
                        }
                        .component-ConfirmationPopup
                            .button-row
                            a:nth-child(even)
                            .popup-button {
                            margin-left: 10px;
                        }
                        .component-ConfirmationPopup .button-row {
                            display: flex;
                        }
                        .component-ConfirmationPopup
                            .button-row
                            a:only-child
                            .popup-button {
                            width: 180px;
                            margin: 20px auto 0;
                        }
                        @media screen and (min-width: 375px) {
                            .component-ConfirmationPopup .popup-container {
                                width: 340px;
                            }
                        }
                        @media screen and (min-width: 576px) {
                            .component-ConfirmationPopup .popup-container {
                                width: 500px;
                            }
                        }
                    `}
                </style>
                <Overlay handleClose={onClose}>
                    <div className="modal-scroll">
                        <div className="popup-container">
                            <div className="popup-content flex-align-justify-center">
                                <img
                                    alt="confirmation"
                                    src={buildImagePath(imageSrc, 'xLarge')}
                                />
                                <span className="heading flex-align-justify-center">
                                    {heading}
                                </span>
                                <span className="subheading flex-align-justify-center">
                                    {subheading}
                                </span>

                                {inputOnChange && (
                                    <InputField
                                        classname="popup-input"
                                        changeHandler={inputOnChange}
                                    />
                                )}
                                <ErrorLabel error={this.props.inputError} />

                                <div className="button-row">
                                    {buttonMetas.map(this.renderButton)}
                                </div>
                            </div>
                        </div>
                    </div>
                </Overlay>
            </div>
        );
    }
}
